import React, { useEffect, useState, useContext } from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { PlaceStoreContext } from '../../../../../reducers/Place/PlaceContext';
import { AuthContext } from '../../../../../reducers/Auth/AuthContext';
import RePositionListSmall from '../../../../../components/RePositionListSmall';
import BarLoader from 'react-spinners/BarLoader';
import { updateOrderOfToppings } from '../../../../../apis/updateOrderOfToppings';
import { COLORS } from '../../../../../utils/colors';
import PublishButton from '../../../../../components/PublishButton';

const RepositionToppings = (props) => {
  const { toppingGroup, close } = props;

  const [placeState] = useContext(PlaceStoreContext);
  const [authState] = useContext(AuthContext);
  const {
    user: { placeId },
  } = authState;
  const {
    toppings: { indexToppings: { toppingGroupId__toppings } },
  } = placeState;

  const [items, setItems] = useState(null);
  const [positions, setPositions] = useState(null);
  const [submiting, setSubmiting] = useState(false);

  useEffect(() => {
    if (!toppingGroupId__toppings[toppingGroup.id]) return;
    setItems(toppingGroupId__toppings[toppingGroup.id].sort((a, b) => a.position - b.position));
  }, [placeState]);

  const handlePositionChanges = async () => {
    setSubmiting(true);
    const hasPositions = positions !== null;
    if (hasPositions) {
      await updateOrderOfToppings(placeId, toppingGroup.id, positions);
    }
    close();
  }

  if (submiting)
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: `calc(100vw - ${Math.round((window.innerWidth * 8) / 100)}px)`,
          height: '80vh',
          margin: '0 auto',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <p style={{ margin: 0, paddingBottom: '20px', fontWeight: 'bold' }}>SAVING CHANGES</p>
          <BarLoader height={4} width={100} color="#000000" loading={true} />
        </div>
      </div>
    );

  return (
    <Grid container spacing={2} justify="center" style={{ maxWidth: '500px', marginTop: '20px' }}>
      <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
        <div>
          <p
            style={{
              fontSize: '0.8rem',
              fontWeight: 'bold',
              color: COLORS.INFO,
              textAlign: 'center',
              marginBottom: '20px',
            }}
          >{`REPOSITION TOPPINGS IN ${toppingGroup.name.toUpperCase()}`}</p>
          <p
            style={{
              fontSize: '0.8rem',
              color: COLORS.INFO,
              textAlign: 'center',
              marginBottom: '20px',
            }}
          >
            Drag and drop to reposition
          </p>
        </div>
      </Grid>
      <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
        <PublishButton
          name="SAVE CHANGES AND PUBLISH"
          disabled={positions === null}
          onClick={handlePositionChanges}
          style={{ marginBottom: '10px' }}
        />
      </Grid>
      <Grid item xs={12}>
        <RePositionListSmall
          items={items}
          setItems={setItems}
          setPositions={setPositions}
        />
      </Grid>
    </Grid>
  );
};

export default RepositionToppings;
